/**
 * Item class for encrypted, encrypted and signed S/MIME message
 */
export const ITEM_CLASS_SMIME = 'IPM.Note.SMIME';
